import { procurementAPI } from "../../axios";

export const actions = {
    GetAppTools(){
        return procurementAPI.get(`AppTool/GetAll`);
    },
    CreateAppTool(context, data){
        return procurementAPI.post(`AppTool/Create`, data);
    },
    UpdateAppTool(context, data){
        return procurementAPI.put(`AppTool/${data.id}`, data);
    },
    DeleteAppTool(context, data){
        return procurementAPI.delete(`AppTool/${data}`);
    },
    GetSingleAppTool(context, data){
        return procurementAPI.get(`AppTool/${data}`);
    }
}